module.exports = __webpack_public_path__ + "19a7ce2e215540a3f26f1badea163f62.png";